module.exports = __webpack_public_path__ + "static/media/grupo.cd7330bb.png";